<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form>
          <h1 tabindex="0">Visualizar Transmissão</h1>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="form.titulo"
                                autofocus
                                disabled
                                />
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Data da Transmissão:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask='"##/##/####"'
                                type="text"
                                class="form-control"
                                placeholder="Data da Transmissão"
                                autocomplete="data"
                                v-model="form.data"
                                disabled
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Data da transmissão é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Inserir Horário de Transmissão:">
                  <b-form-radio-group v-model="form.possui_hora"  id="radio-slots" :options="options_horario" name="radio-options-slots" disabled/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6" v-if="form.possui_hora">
              <b-form-group tabindex="0" label="Hora de Início Transmissão:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask='"##:##"'
                                type="text"
                                class="form-control"
                                placeholder="Hora da Transmissão"
                                autocomplete="hora"
                                v-model="form.hora"
                                autofocus
                                disabled />
                  <b-form-invalid-feedback id="input1LiveFeedback1">Hora de início é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6" v-if="form.possui_hora">
              <b-form-group tabindex="0" label="Hora de Término Transmissão:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask='"##:##"'
                                type="text"
                                class="form-control"
                                placeholder="Hora de Término Transmissão"
                                autocomplete="hora_termino"
                                v-model="form.hora_termino"
                                autofocus
                                disabled />
                  <b-form-invalid-feedback id="input1LiveFeedback1">Hora de término é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Habilitar Comentários:">
                <b-form-radio-group v-model="form.permite_comentarios" id="radio-slots2" :options="options_permite_comentarios" name="radio-options-slots2" disabled />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Habilitar Live:">
                <b-form-radio-group v-model="form.aovivo"  id="radio-slots3" :options="options_aovivo" name="radio-options-slots3" disabled />
              </b-form-group>
            </b-col>  
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Url do Vídeo:">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Url do Vídeo"
                                autocomplete="url"
                                v-model="form.url"
                                autofocus
                                disabled />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Url da Live:" >
                  <b-form-input tabindex="0" type="text"
                                class="form-control"
                                placeholder="Url da Live"
                                autocomplete="url_facebook"
                                v-model="form.url_facebook"
                                autofocus
                                disabled />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>       
            <b-col sm="12" md="12" lg="6">
                 <b-form-group tabindex="0" label="Canal:">
                  <b-form-select :disabled="true" v-model.trim="form.canal"
                                 placeholder="Canal" class="mb-3">
                    <option value="null" selected> Selecione </option>
                    <option v-for="item in options_canal" :key="item.value" :value="item.value"> {{item.text}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback9">Canal é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            </b-row>
            <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group tabindex="0" label="Banner do Vídeo: * (.jpg, .jpeg ou .png)" for="banner">               
                <b-form-file tabindex="0" id="banner" :disabled="true"  ref="banner"  placeholder="Escolha um arquivo..." accept="image/jpeg, image/png" browse-text="Selecionar"/>
                <span v-if="mostra_banner"><a :href="form.banner" target="_blank">banner_video.jpeg</a></span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col sm="12" md="4" lg="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/sala')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  name: 'Cadastro',
  created () {
    if (!this.can('salatransmissao.show')) {
      // this.$router.push('/')
    }
    this.loadSala(this.$route.params.id)
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        data: '',
        hora: '',
        url: '',
        url_facebook: '',
        atual: false,
        possui_hora: false,
        permite_comentarios: false,
        aovivo: false,
        canal: null,
        banner: null
      },
      mostra_banner: false,
      options_transmissao: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_horario: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_permite_comentarios: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_aovivo: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_canal: [
        { text: 'Facebook', value: 'F'},
        { text: 'YouTube', value: 'Y' }
      ],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      disable_url_facebook: true,
      disable_url: false
    }
  },
  computed: {
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    loadSala (id) {
      Vue.http.get('api/salaTransmissao/' + id).then(response => {
        let data = response.body.data[0]
        this.form.titulo = data.titulo
        this.form.url = data.url_video
        this.form.url_facebook = data.url_facebook
        this.form.atual = data.atual
       if(data.banner !== null){
          this.mostra_banner = true
        }
        this.form.banner = data.banner
        this.form.canal = data.canal

        let dataHora = data.data_hora
        let dataTransmissao = dataHora.split(' ')[0]
        this.form.data = dataTransmissao

        if (data.data_hora_termino) {
          let dataTransmissao = dataHora.split(' ')[1]
          this.form.hora = dataTransmissao

          let dataHoraTermino = data.data_hora_termino
          if (dataHoraTermino) {
            let horaTransmissaoTermino = dataHoraTermino.split(' ')[1]
            this.form.hora_termino = horaTransmissaoTermino
          }

          this.form.possui_hora = true
        } else {
          this.form.possui_hora = false
        }

        this.form.permite_comentarios = data.permite_comentarios ? data.permite_comentarios : false
        this.form.aovivo = data.aovivo
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/salas/SalaVisualizar.vue